import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-env-activity-resources';

@Injectable({
    providedIn: 'root'
})
export class ActivityService {

    constructor(private fabricService: FabricService) {
    }

    getInstanceActivityLogs(id: string, page: number = 0, size: number = 10): Observable<any> {
      return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_activity', { id, page, size });
    }
    
    getInstanceActivityLogsById(id, activityId): Observable<any> {
      return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_activity_activityid', {id,activityId});
    }

}